module.exports = "0.8.2";



//////////////////
// WEBPACK FOOTER
// ./node_modules/dagre/lib/version.js
// module id = 471
// module chunks = 0